import { AxiosResponse } from 'axios'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import casinoService from '../../services/casino.service'
import {
  selectCasinoMatchList,
} from '../../redux/actions/casino/casinoSlice'

import { useParams, useSearchParams, useNavigate, useLocation } from 'react-router-dom'
import { CustomLink } from '../_layout/elements/custom-link'
import CasinoListItemInt from '../CasinoList/CasinoListItemInt'
import authService from '../../services/auth.service'
import { isMobile } from 'react-device-detect'
import './casino.css'
import { useGameOverlayHistory } from '../../hooks/useGameOverlayHistory'
import GameAlertBanner from '../../components/GameAlertBanner/GameAlertBanner'
import { resolveCasinoGameUid } from '../../utils/casinoGameLaunch'
import {
  buildProviderLobbyUrl,
  canAutoOpenProviderLobby,
} from '../../utils/providerLobbyUrl'

const DEFAULT_VIS_CONFIG = { disabledProviders: [] as string[], disabledGames: [] as string[], overrideImages: {} as Record<string, string>, useCustomImage: {} as Record<string, boolean> }

const CasinoOther = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const gamesList = useAppSelector<any>(selectCasinoMatchList)
  const [visibilityConfig, setVisibilityConfig] = React.useState(DEFAULT_VIS_CONFIG)

  useEffect(() => {
    casinoService.getCasinoVisibilityConfig()
      .then((res: AxiosResponse<any>) => {
        const data = res.data?.data || res.data || {}
        setVisibilityConfig({
          disabledProviders: data.disabledProviders || [],
          disabledGames: data.disabledGames || [],
          overrideImages: data.overrideImages || {},
          useCustomImage: data.useCustomImage || {},
        })
      })
      .catch(() => setVisibilityConfig(DEFAULT_VIS_CONFIG))
  }, [])
  const [searchParams] = useSearchParams();
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = document.querySelector('.desktop-layout-wrapper');
      // Fallback to window if container not found
      const currentScroll = scrollContainer ? scrollContainer.scrollTop : window.scrollY;

      if (currentScroll > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };

    const scrollContainer = document.querySelector('.desktop-layout-wrapper');
    const target = scrollContainer || window;
    target.addEventListener('scroll', handleScroll);

    return () => target.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    const scrollContainer = document.querySelector('.desktop-layout-wrapper');
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  const queryp = useParams();
  const category = searchParams.get("category")
  const gameType = searchParams.get("gameType") // e.g. "mines" for Mine games from all providers
  const playGameId = searchParams.get("play") // auto-launch from Live Casino lobby
  const [games, setGames] = React.useState<any>([])
  const [provider, setProvider] = React.useState<any>([])
  const [categorylist, setCategoryList] = React.useState<any>([])
  const [gamePlay, setGamePlay] = React.useState<any>()
  const [gameUrl, setGameUrl] = React.useState<string>('')
  const [showIframe, setShowIframe] = React.useState(false)
  const [catName, setCatName] = React.useState<string>('')
  const showSlotCategories = false
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track dropdown visibility
  const dropdownRef = useRef(null);
  const navRef = useRef<HTMLElement>(null); // Ref for casino nav to scroll to active tab
  const catNavRef = useRef<HTMLDivElement>(null); // Ref for category list
  const [activeCategory, setActiveCategory] = useState<string>(provider?.[0]?._id || "");
  const [selectedGameTypeProvider, setSelectedGameTypeProvider] = useState<string | null>(null); // null = All providers (for game-type views)

  const lobbyJumpDoneRef = useRef(false)

  const closeCasinoGame = useCallback(() => {
    setGamePlay(undefined)
    setGameUrl('')
    setShowIframe(false)
    lobbyJumpDoneRef.current = false
  }, [])

  /** After session bootstrap, jump iframe to Evolution lobby SPA (optional category) */
  const jumpToProviderLobby = useCallback(
    (fromUrl: string, provider?: unknown, evoCategory?: string | null) => {
      if (lobbyJumpDoneRef.current) return
      const lobbyUrl = buildProviderLobbyUrl(fromUrl, provider, evoCategory)
      if (!lobbyUrl || lobbyUrl === fromUrl) return
      lobbyJumpDoneRef.current = true
      setGameUrl(lobbyUrl)
    },
    [],
  )

  const launchGameIfLoggedIn = useCallback(
    (game: any) => {
      if (!authService.getToken()) {
        toast.info('Please log in to play.', { position: 'top-center', autoClose: 3500 })
        navigate('/dash', {
          state: {
            openLogin: true,
            from: `${location.pathname}${location.search}`,
          },
        })
        return
      }
      setGamePlay(game)
    },
    [navigate, location.pathname, location.search]
  )

  const closeGameOverlay = useGameOverlayHistory(!!gamePlay, closeCasinoGame)

  const isGameTypeView = Boolean(gameType); // mines, fortune-spin, aviator, etc.
  // Map gameType to backend search term(s). Multiple terms = run multiple searches and merge (e.g. aviator + airjet + astronaut).
  const GAME_TYPE_SEARCH_TERMS: Record<string, string[]> = {
    mines: ['mines'],
    'fortune-spin': ['fortune'],
    aviator: ['aviator', 'airjet', 'astronaut'],
    'card-games': ['teen patti', 'rummy', 'poker', 'andar bahar', 'baccarat', 'dragon tiger'],
    'live-casinos': ['live casino', 'live', 'casino live'],
    'slot-games': ['slot', 'slot game', 'slots'],
    fishing: ['fishing', 'fish', 'fish game'],
    multiplayer: [
      'multiplayer',
      'Multiplayer Game',
      'Tai Xiu',
      'Xoc Dia',
      'FanTan',
      'Hundred SicBo',
      'Fish Shrimp Crab',
      'Red Black War',
      'Hundreds People of Bull',
      'Jhandi Munda',
      'BEST OF FIVE',
      'THREE DICE',
      'color-game',
      'fast-furious',
      'Slide',
    ],
  };
  const gameTypeSearchTerms = gameType ? (GAME_TYPE_SEARCH_TERMS[gameType] ?? [gameType.replace(/-/g, ' ')]) : [];
  const gameTypeTitle =
    gameType === "mines"
      ? "Mine games"
      : gameType === "fortune-spin"
        ? "Fortune Spin games"
        : gameType === "aviator"
          ? "Aviator games"
          : gameType === "card-games"
            ? "Card games"
            : gameType === "live-casinos"
              ? "Live Casino games"
              : gameType === "slot-games"
                ? "Slot games"
                : gameType === "fishing"
                  ? "Fishing games"
                  : gameType === "multiplayer"
                    ? "Multiplayer games"
                    : gameType
                      ? gameType.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) + " games"
                      : "";

  // Unique providers that have games for this game type (from search result)
  const gameTypeProviders = React.useMemo(() => {
    if (!isGameTypeView || !games.length) return [];
    const set = new Set<string>();
    games.forEach((g: any) => {
      const p = g.provider || g.provider_name || g.provider_id;
      if (p && String(p).trim()) set.add(String(p).trim());
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [isGameTypeView, games]);

  console.log(queryp)
  console.log(category)
  // Multiplayer subcategory filter: same as main casino page (game_category / game_group)
  const isMultiplayerCategory = (g: any) => {
    const cat = (g.game_category || g.game_group || "").toString().trim();
    return cat === "Multiplayer" || cat === "Multiplayer Game";
  };

  React.useEffect(() => {
    if (isGameTypeView && gameTypeSearchTerms.length > 0) {
      const searchPromises = gameTypeSearchTerms.map((term) =>
        casinoService.searchCasinoGames(term).then((res: AxiosResponse<any>) => res.data?.result || [])
      );
      Promise.all(searchPromises)
        .then((resultsArrays) => {
          const seen = new Set<string>();
          const merged: any[] = [];
          resultsArrays.flat().forEach((g: any) => {
            const id = g._id || g.game_identifier;
            if (id && !seen.has(id)) {
              seen.add(id);
              merged.push(g);
            }
          });

          // For multiplayer: also fetch by provider (same as main casino) and filter by subcategory so we get all games (e.g. 2J's 16)
          if (gameType === "multiplayer") {
            const providerNames = Array.from(
              new Set(
                merged
                  .map((g: any) => (g.provider || g.provider_name || g.provider_id)?.toString?.()?.trim())
                  .filter(Boolean)
              )
            );
            if (providerNames.length > 0) {
              const providerPromises = providerNames.map((p: string) =>
                casinoService
                  .getIntCasinoList(p, queryp.type)
                  .then((res: AxiosResponse<any>) => {
                    const list = res.data?.result || [];
                    return list.filter((g: any) => isMultiplayerCategory(g));
                  })
                  .catch(() => [])
              );
              Promise.all(providerPromises).then((providerResults) => {
                const byProvider = providerResults.flat();
                byProvider.forEach((g: any) => {
                  const id = g._id || g.game_identifier;
                  if (id && !seen.has(id)) {
                    seen.add(id);
                    merged.push(g);
                  }
                });
                setGames(merged);
                setProvider([]);
                setCategoryList([]);
                setCatName("All");
                setSelectedGameTypeProvider(null);
              });
              return;
            }
          }

          setGames(merged);
          setProvider([]);
          setCategoryList([]);
          setCatName("All");
          setSelectedGameTypeProvider(null);
        })
        .catch(() => setGames([]));
      return;
    }
    casinoService
      .getIntCasinoList(category, queryp.type)
      .then((res: AxiosResponse<any>) => {
        const data = res.data
        setGames(data.result)
        if (provider.length === 0 || provider[0]?.type !== queryp.type) {
          setProvider(data.providers)
        }
        setCategoryList(data.category)
        setCatName('All')

        if (!category && data.providers && data.providers.length > 0) {
          navigate(`/casino-int/${queryp.type}?category=${data.providers[0]._id}`, { replace: true })
        }
      })
      .catch(() => {
        setGames([])
        setProvider([])
        setCategoryList([])
      })
  }, [category, queryp.type, isGameTypeView, gameType])

  // Clear providers when type changes to ensure we fetch fresh ones
  React.useEffect(() => {
    setProvider([])
  }, [queryp.type])

  useEffect(() => {
    setActiveCategory(category || "");
  }, [category]);

  // Auto-launch once when arriving from Home Lobby GAMES / Live Casino
  // (state.openGame | state.playGame | ?play=) — same as frontend casinoOther
  const autoPlayDoneRef = useRef(false)
  useEffect(() => {
    if (autoPlayDoneRef.current) return

    const state = (location.state as { openGame?: any; playGame?: any } | null) || {}
    const fromState = state.openGame || state.playGame
    const uid = resolveCasinoGameUid(fromState)
    if (fromState && uid) {
      autoPlayDoneRef.current = true
      launchGameIfLoggedIn({ ...fromState, identifier: uid })
      const next = new URLSearchParams(searchParams)
      next.delete('play')
      const q = next.toString()
      navigate(`${location.pathname}${q ? `?${q}` : ''}`, { replace: true, state: {} })
      return
    }

    if (!playGameId || !games?.length) return
    const match = games.find((g: any) => {
      const id = String(g.identifier || g.game_identifier || g._id || '')
      return id === playGameId
    })
    if (!match) return

    autoPlayDoneRef.current = true
    launchGameIfLoggedIn(match)
    const next = new URLSearchParams(searchParams)
    next.delete('play')
    const q = next.toString()
    navigate(`${location.pathname}${q ? `?${q}` : ''}`, { replace: true, state: {} })
  }, [playGameId, games, location.state, location.pathname, searchParams, navigate, launchGameIfLoggedIn])

  // Auto-scroll to active tab when category changes or providers load
  useEffect(() => {
    if (category && navRef.current) {
      // Find the active tab element
      const activeTab = navRef.current.querySelector('.nav-tab.active');
      if (activeTab) {
        // Scroll the nav container to show the active tab
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [category, provider]);

  // Auto-scroll subcategory list
  useEffect(() => {
    if (catNavRef.current) {
      const activeBtn = catNavRef.current.querySelector('.casino-category-btn.active');
      if (activeBtn) {
        activeBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }, [catName, categorylist]);

  // Add/remove body class when game is playing; scroll to top when opening game
  React.useEffect(() => {
    if (gamePlay) {
      document.body.classList.add('casino-game-playing');
      window.scrollTo(0, 0);
    } else {
      document.body.classList.remove('casino-game-playing');
    }
    return () => {
      document.body.classList.remove('casino-game-playing');
    };
  }, [gamePlay]);

  // Reset showIframe when game closes
  React.useEffect(() => {
    if (!gamePlay) setShowIframe(false);
  }, [gamePlay]);

  // Delay iframe mount ~120ms after gameUrl is ready (iOS Safari playbook)
  React.useEffect(() => {
    if (!gameUrl) return;
    const t = setTimeout(() => setShowIframe(true), 120);
    return () => clearTimeout(t);
  }, [gameUrl]);

  React.useEffect(() => {
    if (gamePlay) {
      const gameUid = resolveCasinoGameUid(gamePlay) || String(gamePlay.identifier || '')
      if (!gameUid) {
        toast.error('Invalid game. Please pick the game again.')
        setGamePlay(undefined)
        return
      }

      const payload: any = {
        gameCode: gameUid,
        lobby_url: gameUid,
        ipAddress: authService.getIpAddress(),
        isMobile: isMobile,
      }

      // ✅ Wrap in try-catch to prevent uncaught errors
      const loadCasino = async () => {
        try {
          const res = await casinoService.getplaycasino(payload)
          const data = res?.data
          const raw = data?.data?.url ?? data?.data?.playUrl ?? data?.data?.play_url ?? data?.data?.gameUrl ?? data?.url ?? data?.playUrl
          const url = raw && typeof raw === 'string' ? raw.trim() : null
          if (url) {
            const provider =
              gamePlay.game_provider || gamePlay.provider || gamePlay.provider_name || category
            if (gamePlay.openProviderLobby && canAutoOpenProviderLobby(provider)) {
              // Evolution: load session first, then jump to lobby SPA / category
              lobbyJumpDoneRef.current = false
              setGameUrl(url)
              window.setTimeout(
                () => jumpToProviderLobby(url, provider, gamePlay.evoCategory),
                4500,
              )
            } else {
              setGameUrl(url)
            }
          } else {
            toast.error('Game could not be loaded. Please try again.')
            setGamePlay(undefined)
          }
        } catch (error: any) {
          console.log('Casino play error:', error)

          // ✅ Handle 401 errors gracefully without logging out
          if (error.response?.status === 401 || error.response?.status === 500) {
            // Parse error message if available
            let errorMsg = 'This is not available currently'

            try {
              const responseMsg = error.response?.data?.message
              if (responseMsg && typeof responseMsg === 'string') {
                // Try to parse nested JSON error message
                const parsed = JSON.parse(responseMsg)
                if (parsed.msg) {
                  const innerParsed = JSON.parse(parsed.msg)
                  errorMsg = innerParsed.message || innerParsed.error || errorMsg
                }
              }
            } catch (parseError) {
              // If parsing fails, use default message
              console.log('Could not parse error message:', parseError)
            }

            toast.error(errorMsg, {
              position: 'top-center',
              autoClose: 4000
            })
            // Reset game play to close the iframe
            setGamePlay(undefined)
          } else {
            // For other errors, show generic message
            toast.error('Unable to load casino game. Please try again later.', {
              position: 'top-center',
              autoClose: 3000
            })
            setGamePlay(undefined)
          }
        }
      }

      loadCasino()
    }
  }, [gamePlay])
  useEffect(() => {
    if (categorylist.length > 0 && !catName) {
      setCatName(categorylist[0]._id);
    }
  }, [categorylist]);

  // Search functionality
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim().length >= 2) {
        setIsLoading(true)
        setIsDropdownOpen(true)

        casinoService.searchCasinoGames(searchQuery)
          .then((res: AxiosResponse<any>) => {
            setSuggestions(res.data.result || [])
            setIsLoading(false)
          })
          .catch((error) => {
            console.error('Search error:', error)
            setSuggestions([])
            setIsLoading(false)
          })
      } else {
        setSuggestions([])
        setIsDropdownOpen(false)
      }
    }, 300) // Debounce 300ms

    return () => clearTimeout(delayDebounceFn)
  }, [searchQuery])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !(dropdownRef.current as any).contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSuggestionClick = (game: any) => {
    launchGameIfLoggedIn(game)
    setSearchQuery('')
    setSuggestions([])
    setIsDropdownOpen(false)
  }

  console.log(provider)

  // Filter out hidden providers from the provider tabs
  const visibleProviders = React.useMemo(() => {
    if (!visibilityConfig.disabledProviders.length) return provider;
    return provider.filter((p: any) => !visibilityConfig.disabledProviders.includes(p._id))
  }, [provider, visibilityConfig.disabledProviders])

  // Filter games based on selected category (and for game-type views, by selected provider)
  // Also exclude games/providers hidden via Casino Visibility admin
  const filteredGames = React.useMemo(() => {
    let list = games;
    // Remove games whose provider is hidden
    if (visibilityConfig.disabledProviders.length) {
      list = list.filter((g: any) => {
        const pid = g.provider_id || g.provider || g.game_provider;
        return !pid || !visibilityConfig.disabledProviders.includes(String(pid));
      });
    }
    // Remove individually hidden games
    if (visibilityConfig.disabledGames.length) {
      list = list.filter((g: any) => {
        const gid = g.game_identifier || g.identifier || g._id;
        return !gid || !visibilityConfig.disabledGames.includes(String(gid));
      });
    }
    if (isGameTypeView) {
      if (selectedGameTypeProvider) {
        list = list.filter((g: any) => {
          const p = g.provider || g.provider_name || g.provider_id;
          return p && String(p).trim() === selectedGameTypeProvider;
        });
      }
      return list;
    }
    if (!catName || catName === 'All') return list;
    return list.filter((game: any) => {
      const category = game.game_category || game.live_category || game.slot_category;
      return category === catName;
    });
  }, [games, catName, isGameTypeView, selectedGameTypeProvider, visibilityConfig]);

  return (
    <div className="casino-page-wrap">
      <div className="w-100 mb-4">
        {/* Casino Banner Image */}
        <div className="casino-banner">
          <img src="/imgs/lotus_update/Casino.webp" alt="Casino Banner" />
        </div>

        {/* Casino Search Bar */}
        <div className="nav-search-main mb-3">
          <div className="nav-search-input-wrapper w-100" ref={dropdownRef}>
            <input
              type="text"
              placeholder="Search Games (Atleast 3 chars....)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => searchQuery && setIsDropdownOpen(true)}
              className="nav-search-input w-100"
            />
            <span className="nav-search-icon">
              {isLoading ? "⌛" : "🔍"}
            </span>

            {/* Suggestions dropdown */}
            {isDropdownOpen && searchQuery && suggestions.length > 0 && (
              <div className="nav-search-suggestions">
                {suggestions.map((game: any, index: number) => (
                  <div
                    key={index}
                    className="search-suggestion-item"
                    onClick={() => handleSuggestionClick(game)}
                    style={{
                      cursor: 'pointer',
                      padding: '10px',
                      borderBottom: '1px solid #eee',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                  >
                    <img
                      src={(() => {
                        const gid = game.game_identifier || game.identifier || game._id
                        const override = gid && visibilityConfig.overrideImages?.[gid]
                        if (override && visibilityConfig.useCustomImage?.[gid]) {
                          const base = (process.env.REACT_APP_API_BASEURL || '').replace(/\/api\/?$/, '')
                          return override.startsWith('http') ? override : `${base}${override}`
                        }
                        return game.game_images || game.image_url || game.game_image || ''
                      })()}
                      alt={game.game_name}
                      style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '4px'
                      }}
                    />
                    <div>
                      <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {game.game_name}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {game.provider}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* No results message */}
            {isDropdownOpen && searchQuery && suggestions.length === 0 && !isLoading && (
              <div className="nav-search-suggestions">
                <div className="no-results">No matches found</div>
              </div>
            )}
          </div>
        </div>

        {/* Game-type view (mines, fortune-spin, etc.): Game Providers section */}
        {isGameTypeView && gameTypeProviders.length > 0 && (
          <div className="game-providers-section" style={{ width: '100%', marginTop: '12px', marginBottom: '8px' }}>
            <div className="game-providers-header" style={{ padding: '0 5px', marginBottom: '8px' }}>
              <h5 style={{ fontWeight: "700", color: "#333", textTransform: "capitalize" }}>Game Providers</h5>
            </div>
            <div className="casino-categories-row" style={{ padding: '0 5px' }}>
              <div className="casino-categories-scroll" style={{ display: 'flex', gap: '8px', overflowX: 'auto', scrollbarWidth: 'none', paddingBottom: '5px' }}>
                <button
                  type="button"
                  className={`casino-category-btn ${selectedGameTypeProvider === null ? 'active' : ''}`}
                  onClick={() => setSelectedGameTypeProvider(null)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '20px',
                    border: '1px solid #E5E7EB',
                    background: selectedGameTypeProvider === null ? '#2C4F58' : '#fff',
                    color: selectedGameTypeProvider === null ? '#fff' : '#333',
                    fontWeight: 600,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                >
                  All
                </button>
                {gameTypeProviders.map((provName: string) => (
                  <button
                    key={provName}
                    type="button"
                    className={`casino-category-btn ${selectedGameTypeProvider === provName ? 'active' : ''}`}
                    onClick={() => setSelectedGameTypeProvider(provName)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '20px',
                      border: '1px solid #E5E7EB',
                      background: selectedGameTypeProvider === provName ? '#2C4F58' : '#fff',
                      color: selectedGameTypeProvider === provName ? '#fff' : '#333',
                      fontWeight: 600,
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                    }}
                  >
                    {provName}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Game Categories Row - hide when showing game-type view */}
        {!isGameTypeView && categorylist && categorylist.length > 0 && (
          <div className="casino-categories-row">
            <div className="casino-categories-scroll" ref={catNavRef}>
              <button
                className={`casino-category-btn ${catName === 'All' ? 'active' : ''}`}
                onClick={() => setCatName('All')}
              >
                All
              </button>
              {categorylist.map((cat: any, index: number) => (
                <button
                  key={index}
                  className={`casino-category-btn ${catName === cat._id ? 'active' : ''}`}
                  onClick={() => setCatName(cat._id)}
                >
                  {cat._id || 'All'}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Game Providers Section - hide when showing game-type view (mines, fortune-spin, etc.) */}
        {!isGameTypeView && (
        <div className="game-providers-section" style={{ width: '100%', marginTop: '12px', marginBottom: '8px' }}>
          <div className="game-providers-header" style={{ padding: '0 5px', marginBottom: '8px' }}>
            <h5 style={{ fontWeight: "700", color: "#333", textTransform: "capitalize" }}>Game Providers</h5>
          </div>
          <div className="game-providers-grid-container" style={{ padding: '0 5px', overflowX: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            <div className="game-providers-grid" style={{ display: 'flex', gap: '10px', width: 'max-content', paddingBottom: '5px' }}>
              {[
                'evolution', 'ezugi', 'netent', 'redtiger', 'spribe', 'playtech',
                'smartsoftgaming', 'bgaming', 'cq9', 'jdb', 'jili', 'pgs',
                'kingmidas', 'nolimitcity', 'relax', 'bigtimegaming', 'onegaming', 'inout'
              ].map((providerName, index) => (
                <div
                  key={index}
                  className="game-provider-card"
                  style={{
                    width: '140px',
                    height: '60px',
                    minWidth: '140px',
                    background: '#ffffff',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    cursor: 'pointer',
                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
                  }}
                  onClick={() => {
                    // Mapping logic as requested
                    const lowerName = providerName.toLowerCase();
                    let targetCategory = "";

                    if (lowerName === 'evolution') {
                      targetCategory = "Evolution Live";
                    } else if (lowerName === 'ezugi') {
                      targetCategory = "Ezugi";
                    } else if (lowerName === 'netent') {
                      targetCategory = "Netent Asia";
                    }
                    else if (lowerName === 'redtiger') {
                      targetCategory = "Red Tiger";
                    }
                    else if (lowerName === 'spribe') {
                      targetCategory = "Spribe";
                    }
                    else if (lowerName === 'playtech') {
                      targetCategory = "Playtech";
                    }
                    else if (lowerName === 'smartsoftgaming') {
                      targetCategory = "Smartsoft";
                    }
                    else if (lowerName === 'bgaming') {
                      targetCategory = "Bgaming";
                    }
                    else if (lowerName === 'cq9') {
                      targetCategory = "CQ9";
                    }
                    else if (lowerName === 'jdb') {
                      targetCategory = "JDBGaming";
                    }
                    else if (lowerName === 'jili') {
                      targetCategory = "JILI";
                    }
                    else if (lowerName === 'pgs') {
                      targetCategory = "PG Soft";
                    }
                    else if (lowerName === 'kingmidas') {
                      targetCategory = "KM";
                    }
                    else if (lowerName === 'nolimitcity') {
                      targetCategory = "NoLimit City";
                    }
                    else if (lowerName === 'relax') {
                      targetCategory = "RelaxGaming";
                    }
                    else if (lowerName === 'bigtimegaming') {
                      targetCategory = "BigTimeGaming";
                    }
                    else if (lowerName === 'onegaming') {
                      targetCategory = "OneGaming";
                    }
                    else if (lowerName === 'inout') {
                      targetCategory = "InOut";
                    }
                    // Add more mappings here as placeholders

                    if (targetCategory && queryp.type) {
                      navigate(`/casino-int/${queryp.type}?category=${encodeURIComponent(targetCategory)}`);
                    }
                  }}
                >
                  <img
                    src={`/imgs/game_providers/${providerName}.svg`}
                    alt={providerName}
                    className="game-provider-logo"
                    style={{ height: '95%', width: '95%', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        )}

        {!isGameTypeView && (
        <div className="w-100">
          <nav className="casino-nav custom-gaming-scrollbar" ref={navRef}>
            {visibleProviders.map((Item: any, key: number) => {
              const isActive =
                Item._id === activeCategory ||
                (!category && key === 0);

              return (
                <CustomLink
                  className={`nav-tab ${isActive ? "active" : ""}`}
                  to={`/casino-int/${queryp.type}?category=${Item._id}`}
                  onClick={() => setActiveCategory(Item._id)}
                >
                  <span className="nav-text">{Item._id}</span>
                </CustomLink>
              );
            })}
          </nav>
        </div>
        )}
        {showSlotCategories && (
          <div className="w-100 mt-2">
            <nav className="casino-nav">
              {categorylist?.map((Item: any, key: number) => {
                const isCategoryActive =
                  catName === Item._id || (!catName && key === 0);

                return (
                  <a
                    key={key}
                    onClick={() => setCatName(Item._id)}
                    href="javascript:void(0);"
                    className={`nav-tab py-2 transition-all ${isCategoryActive ? "active text-white" : "bg-background text-foreground"
                      }`}
                  >
                    <span className="nav-text">{Item._id}</span>
                  </a>
                );
              })}
            </nav>
          </div>
        )}


        {/* Category Title */}
        <div className="w-100 mb-2">
          <h5 style={{ fontWeight: "700", color: "#333", textTransform: "capitalize", marginLeft: "5px" }}>
            {isGameTypeView ? gameTypeTitle : (catName === 'All' ? 'All Games' : `${catName} Games`)}
          </h5>
        </div>

        <div className="casino-list mt-2 custom-gaming-scrollbar casino-list-scroll-container"
        //  style={{ marginLeft: "-6px" }}
        >
          {filteredGames.length > 0 ? (
            <CasinoListItemInt games={filteredGames} setGamePlay={launchGameIfLoggedIn} overrideImages={visibilityConfig.overrideImages} useCustomImage={visibilityConfig.useCustomImage} />
          ) : (
            <div className="text-center w-100 mt-5" style={{ gridColumn: "1 / -1" }}>
              <p>No games found in this category.</p>
            </div>
          )}
        </div>
      </div>

      <GameAlertBanner gamePlay={gamePlay} />

      {/* Game iframe OUTSIDE main content (avoids freeze); mount only when gameUrl ready + 120ms delay */}
      {gamePlay?.game_name && (
        <div className="slot-iframe show">
          <div className="slot-header">
            <div className="title"><h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "400" }}>{gamePlay?.game_name}</h4></div>
            <div className="close-slot-frame" onClick={closeGameOverlay}>EXIT</div>
          </div>
          {gameUrl ? (
            showIframe ? (
              <iframe
                src={gameUrl}
                title={gamePlay?.game_name}
                allow="autoplay; fullscreen; clipboard-read; clipboard-write"
                allowFullScreen
                style={{ width: '100%', border: 'none' }}
              />
            ) : (
              <div className="slot-iframe-loading">
                <div className="lds-hourglass" />
              </div>
            )
          ) : (
            <div className="slot-iframe-loading">
              <div className="lds-hourglass" />
            </div>
          )}
        </div>
      )}

      {/* Scroll to Top Button */}
      {
        showTopBtn && (
          <button
            onClick={scrollToTop}
            style={{
              position: 'fixed',
              bottom: '40px',
              right: '25px',
              height: '45px',
              width: '45px',
              borderRadius: '50%',
              backgroundColor: '#0F2326',
              color: '#fff',
              border: 'none',
              outline: 'none',
              cursor: 'pointer',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
              transition: 'all 0.3s ease'
            }}
            title="Scroll to Top"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 19V5M5 12l7-7 7 7" />
            </svg>
          </button>
        )
      }




      {/* old code */}
      {/* <div className='container-fluid container-fluid-5 cas-in-list'>
        <div className='row row5'>
          <div className='col-xl-2 d-none d-xl-flex ' style={{marginTop:"5px"}}>
            <ul className="nav nav-pills casino-sub-tab">
              {provider.map((Item:any, key:number)=>{
                return <li className="nav-item" key={key}>
                  <CustomLink className={`nav-link ${Item._id == category || (!category && key == 0) ? 'active' : ""}`} to={`/casino-int/${queryp.type}?category=${Item._id}`}><span>{Item._id}</span></CustomLink>
                </li>
              })}             
            </ul>

            </div>
          <div className='col-xl-10 col-12'>
            <div className="casino-sub-tab-list" style={{marginTop:"5px"}}>
              <ul className="nav nav-pills casino-sub-tab" id="casino-sub-tab">
                {categorylist?.map((Item:any, key:number)=>{
                  return  <li className="nav-item" key={key}>
                  <a className={`nav-link ${catName==Item._id?'active':''}`} onClick={()=>{
                    setCatName(Item._id)
                  }} href="javascript:void(0);"><span>{Item._id}</span></a>
                </li>
                })}
               
              </ul>
            </div>
              <div className='casino-list mt-2' style={{ marginLeft: "-6px" }}>
              {games.length > 0 && <CasinoListItemInt games={games} setGamePlay={launchGameIfLoggedIn} overrideImages={visibilityConfig.overrideImages} useCustomImage={visibilityConfig.useCustomImage} />}
              </div>
            </div>
          </div>
        </div>
      */}
    </div>
  )
}
export default CasinoOther
